import React from 'react';

// import { Container } from './styles';

const Api = () => {
  return <div>Api</div>;
};

export default Api;
